module.exports = __webpack_public_path__ + "static/media/nitjlogo.b8e152fd.png";